export interface AuthGateUser {
  email?: string | null;
  emailVerified?: boolean;
  email_verified?: boolean;
}

export function isUserEmailVerified(user: AuthGateUser | null | undefined): boolean {
  return user?.emailVerified === true || user?.email_verified === true;
}

export function verifyEmailPath({
  email,
  next,
}: {
  email?: string | null;
  next: string;
}): string {
  return `/verify-email?email=${encodeURIComponent(email ?? '')}&next=${encodeURIComponent(next || '/onboarding/create-org')}`;
}

export function postSignupPath({
  email,
  nextPath,
  emailVerificationRequired,
}: {
  email: string;
  nextPath: string;
  emailVerificationRequired: boolean;
}): string {
  if (emailVerificationRequired) {
    return verifyEmailPath({ email, next: nextPath });
  }
  return nextPath;
}

export function protectedRouteRedirect({
  user,
  pathname,
  search = '',
}: {
  user: AuthGateUser | null | undefined;
  pathname: string;
  search?: string;
}): string | null {
  if (!user) return '/login';
  if (isUserEmailVerified(user)) return null;
  return verifyEmailPath({ email: user.email, next: `${pathname}${search}` || '/onboarding/create-org' });
}
